import { render } from "./PartsWindow.vue?vue&type=template&id=acc7b6ae"
import script from "./PartsWindow.vue?vue&type=script&lang=js"
export * from "./PartsWindow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__